import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckLoginGuard } from './../../wholesale/auth/check-login.guard';
import { HomeComponent } from './home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      title: 'Home',
      description: `Garden center nursery covering WNY, Buffalo, Amherst, Hamburg, Orchard Park, Clarence, Lancaster. Carrying trees, shrubs, flowers and more.`
    },
    pathMatch: 'full',
    canActivate: [CheckLoginGuard]
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {
      title: 'Home',
      description: `Garden center nursery covering WNY, Buffalo, Amherst, Hamburg, Orchard Park, Clarence, Lancaster. Carrying trees, shrubs, flowers and more.`
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {}
